module.exports = __webpack_public_path__ + "static/media/journal-process.112b6f53.svg";